__turbopack_context__.v({
  "show_grid_card": "_4_kcmG_show_grid_card",
  "show_grid_card__description": "_4_kcmG_show_grid_card__description",
  "show_grid_card__genre": "_4_kcmG_show_grid_card__genre",
  "show_grid_card__logo": "_4_kcmG_show_grid_card__logo",
});
